import React from 'react';
import { jwtDecode } from 'jwt-decode';
import { PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userModel } from '../Interfaces';
import {
  toggleAnimation,
  toggleLayout,
  toggleLocale,
  toggleMenu,
  toggleNavbar,
  toggleRTL,
  toggleSemidark,
  toggleTheme,
} from '../Storage/Redux/slice/themeConfigSlice';
import { setLoggedInUser } from '../Storage/Redux/slice/userAuthSlice';
import store, { IRootState } from '../Storage/Redux/store';
import ErrorBoundary from './ErrorBoundary';
import { getAuthToken } from '../Helper/authToken';

function App({ children }: PropsWithChildren) {
  const themeConfig = useSelector((state: IRootState) => state.themeConfig);
  const dispatch = useDispatch();

  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      const {
        FirstName,
        FranchiseId,
        LastName,
        email,
        Mobile,
        nameid,
        exp,
        role,
      }: userModel = jwtDecode(token);
      dispatch(
        setLoggedInUser({
          FirstName,
          FranchiseId,
          LastName,
          email,
          Mobile,
          nameid,
          exp,
          role,
        })
      );
    }
  }, []);

  useEffect(() => {
    dispatch(toggleTheme(localStorage.getItem('theme') || themeConfig.theme));
    dispatch(toggleMenu(localStorage.getItem('menu') || themeConfig.menu));
    dispatch(
      toggleLayout(localStorage.getItem('layout') || themeConfig.layout)
    );
    dispatch(
      toggleRTL(localStorage.getItem('rtlClass') || themeConfig.rtlClass)
    );
    dispatch(
      toggleAnimation(
        localStorage.getItem('animation') || themeConfig.animation
      )
    );
    dispatch(
      toggleNavbar(localStorage.getItem('navbar') || themeConfig.navbar)
    );
    dispatch(
      toggleLocale(localStorage.getItem('i18nextLng') || themeConfig.locale)
    );
    dispatch(
      toggleSemidark(localStorage.getItem('semidark') || themeConfig.semidark)
    );
  }, [
    dispatch,
    themeConfig.theme,
    themeConfig.menu,
    themeConfig.layout,
    themeConfig.rtlClass,
    themeConfig.animation,
    themeConfig.navbar,
    themeConfig.locale,
    themeConfig.semidark,
  ]);

  return (
    <ErrorBoundary>
      <div
        className={`${
          (store.getState().themeConfig.sidebar && 'toggle-sidebar') || ''
        } ${themeConfig.menu} ${themeConfig.layout} ${
          themeConfig.rtlClass
        } main-section antialiased relative font-nunito text-sm font-normal`}
      >
        {children}
      </div>
    </ErrorBoundary>
  );
}

export default App;
